import { useMutation } from "@apollo/client";
import { EditMeMutation, EditMeMutationVariables } from "gql/graphql";
import { useAuth } from "modules/providers/auth-provider";
import EDIT_ME_MUTATION from "./_networking/edit-me";
import { useCallback } from "react";

const useToggleUserHidePhone = () => {
  const { me } = useAuth();

  const [editMeMutationAPI] = useMutation<
    EditMeMutation,
    EditMeMutationVariables
  >(EDIT_ME_MUTATION);

  return useCallback(() => {
    if (!me) {
      return;
    }

    editMeMutationAPI({
      variables: {
        input: {
          isHidePhone: !me.isHidePhone,
        },
      },
      optimisticResponse: {
        editMe: {
          __typename: "User",
          ...me,
          id: me.id,
          isHidePhone: !me.isHidePhone,
        },
      },
    });
  }, [editMeMutationAPI, me]);
};

export default useToggleUserHidePhone;
